import { MenuProvided } from 'react-instantsearch-core';
import { connectMenu } from 'react-instantsearch-dom';
import React from 'react';
import { Text } from 'atoms/Text/Text';
import { Styles } from './styles';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { logTrackingEvent, CustomEventName } from 'services/analytics';

export const PillMenuConnected: React.FC<MenuProvided> = ({ items, refine }) => {
  const changeFilter = (value: string) => {
    if (value) {
      logTrackingEvent({
        name: CustomEventName.Product_Filter_AOS_Click,
        data: { filter: value },
      });
    }

    refine(value);
  };

  return (
    <Styles.Wrapper>
      {items.map(item => (
        <Styles.Button
          key={item.label}
          active={item.isRefined}
          onClick={() => changeFilter(item.value)}
        >
          <Text.button2
            color={item.isRefined ? defaultTheme.colors.white : defaultTheme.colors.deepBlue}
          >
            {item.label}
          </Text.button2>
        </Styles.Button>
      ))}
    </Styles.Wrapper>
  );
};

export const PillMenu = connectMenu(PillMenuConnected);
